// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cR","cardHeaderIcon_styleDefault":"c-e_cS","cardHeaderIcon_styleRed":"c-e_cT","cardHeaderIcon__content":"c-e_cU"};